function formatHttpErrorMessage(message, error) {
  return `${message}, received http response status code ${error.status}: ${error.message}`;
}

export { formatHttpErrorMessage };
//# sourceMappingURL=formatHttpErrorMessage.esm.js.map
